module.exports = __webpack_public_path__ + "static/media/spotify-icon-newpurple.055e4c13.svg";